import { makeMediaQuery, mediaQuery } from './createMedia'

const color = {
  // Primary

  /** @var '#2535b8' */
  primary900: '#2535b8',
  /** @var '#1f58d8' */
  primary800: '#1f58d8',
  /** @var '#186aea' */
  primary700: '#186aea',
  /** @var '#037bff' */
  primary600: '#037bff',
  /** @var '#008bff' */
  primary500: '#008bff',
  /** @var '#269dff' */
  primary400: '#269dff',
  /** @var '#55aeff' */
  primary300: '#55aeff',
  /** @var '#8ac5ff' */
  primary200: '#8ac5ff',
  /** @var '#b9dbff' */
  primary100: '#b9dbff',
  /** @var '#e2f1ff' */
  primary50: '#e2f1ff',
  /** @var '#f5faff' */
  primary25: '#f5faff',
  /** @var 'rgba(3, 123, 255, 0.16)' */
  primary16a: 'rgba(3, 123, 255, 0.16)',
  /** @var 'rgba(3, 123, 255, 0.08)' */
  primary8a: 'rgba(3, 123, 255, 0.08)',
  /** @deprecated */
  primary5: 'rgb(245 250 255 / 70%)',

  // Secondary

  /** @var '#272d33' */
  secondary900: '#272d33',
  /** @var '#39414a' */
  secondary800: '#39414a',
  /** @var '#485460' */
  secondary700: '#485460',
  /** @var '#586776' */
  secondary600: '#586776',
  /** @var '#657687' */
  secondary500: '#657687',
  /** @var '#7c8998' */
  secondary400: '#7c8998',
  /** @var '#939eaa' */
  secondary300: '#939eaa',
  /** @var '#b2bac1' */
  secondary200: '#b2bac1',
  /** @var '#d1d5d9' */
  secondary100: '#d1d5d9',
  // secondary50: '#e7eef9', // like secondary200 + opacity: 0.24;
  /** @var '#eeeeee' */
  secondary50: '#eeeeee',
  /** @var '#f5f5f5' */
  secondary25: '#f5f5f5',

  // Accent Notify

  /** @var '#e65200' */
  accentNotify900: '#e65200',
  /** @var '#ff9900' */
  accentNotify600: '#ff9900',
  /** @var '#ffe0b2' */
  accentNotify100: '#ffe0b2',
  /** @var '#ffeed3' */
  accentNotify50: '#ffeed3',

  // Accent Approve

  /** @var '#008911' */
  accentApprove800: '#008911',
  /** @var '#20b02e' */
  accentApprove600: '#20b02e',
  /** @var '#34c759' */
  accentApprove400: '#34c759',
  /** @var '#c0ebc5' */
  accentApprove100: '#c0ebc5',
  /** @var '#e6f5e6' */
  accentApprove50: '#e6f5e6',

  // Accent Destruct

  /** @var '#d11922' */
  accentDestruct800: '#d11922',
  /** @var '#ff3b30' */
  accentDestruct500: '#ff3b30',
  /** @var '#ffb4bb' */
  accentDestruct200: '#ffb4bb',
  /** @var '#ffcdd2' */
  accentDestruct100: '#ffcdd2',
  /** @var '#rgba(255, 59, 48, 0.16)' */
  accentDestruct16a: 'rgba(255, 59, 48, 0.16)',

  // accent (old)

  /** @deprecated */
  accentApproving: '#20b02e',
  /** @deprecated */
  accentApproving50: '#e6f5e6',
  /** @deprecated */
  accentNotify: '#ff9900',
  /** @deprecated */
  accentDestructive: '#f10d00',
  /** @deprecated */
  accentDestructive50: `#FFE8E6`,
  /** @deprecated */
  discountEmphasisText: '#FFCD80',
  accentApproving100: '#658D1B',

  // onPrimary

  /** @var '#fff' */
  onPrimaryLight: '#fff',
  /** @var '#111' */
  onPrimaryDark: '#111',
  /** @deprecated */
  onPrimaryMid: '#b3b3b3',

  // onSurface

  /** @deprecated */
  onSurfaceHighEmphasys: 'rgba(0, 0, 0, 0.96)',
  /** @deprecated */
  onSurfaceMidEmphasys: '#858585',
  /** @deprecated */
  onSurfaceLowEmphasys: '#ddd',

  // background

  /** @deprecated */
  backgroundBase: '#fafafa',
  /** @var 'f1f3f5' */
  backgroundPrimary: '#f1f3f5',
  /** @var '#ffffff' */
  backgroundSecondary: '#ffffff',
  /** @var '#e6f5e6' */
  backgroundApproved: '#e6f5e6',
  /** @var '#e5ecf2' */
  backgroundTertiary: '#e5ecf2',

  // Text

  /** @var '#000000' */
  textPrimary: '#000000',
  /** @var 'rgba(60, 60, 67, 0.18)' */
  textQuarternary: 'rgba(60, 60, 67, 0.18)',
  /** @var 'rgba(60, 60, 67, 0.3)' */
  textTertiary: 'rgba(60, 60, 67, 0.3)',
  /** @var 'rgba(60, 60, 67, 0.6)' */
  textSecondary: 'rgba(60, 60, 67, 0.6)',

  // outline

  /** @var '#037bff' */
  outlinePrimary: '#037bff',
  /** @var '#a8b8ca' */
  outlineSecondary: '#a8b8ca',
  /** @var '#ddd' */
  outlineNeutral: '#ddd',
  /** @var rgba(0, 0, 0, 0.08) */
  outlineMid: 'rgba(0, 0, 0, 0.08)',

  // shadow

  /** @var rgba(39, 45, 51, 0.04) */
  shadow4a: 'rgba(39, 45, 51, 0.04)',
  /** @var rgba(39, 45, 51, 0.16) */
  shadow16a: 'rgba(39, 45, 51, 0.16)',
  /** @var rgba(39, 45, 51, 0.25) */
  shadow25a: 'rgba(39, 45, 51, 0.25)',
}

const size = {
  /** @var 236 */
  leftSideBarWidth: 236,
  /** @var 1280 */
  maxContentWidth: 1280,
  /** @var 64 */
  headerHeight: 64,
  /** @var 48 */
  mobileHeaderHeight: 48,
}

const padding = {
  mobile: {
    /** @var `0 0 3px #037bff` */
    content: 16,
  },
}

const shadow = {
  /** @var `0 0 3px #037bff` */
  focus: `0 0 3px ${color.primary600}`,
  /** @var `0 16px 8px 0 rgba(39, 45, 51, 0.04)` */
  blur8: `0 16px 8px 0 ${color.shadow4a}`,
  /** @var `0 16px 24px 0 rgba(39, 45, 51, 0.04)` */
  blur24: `0 16px 24px 0 ${color.shadow4a}`,
  /** @var `0 16px 40px 0 rgba(39, 45, 51, 0.16)` */
  blur40: `0 16px 40px 0 ${color.shadow16a}`,
  /** @var `0 16px 40px 0 rgba(39, 45, 51, 0.25)` */
  blur40Dark: `0 16px 40px 0 ${color.shadow25a}`,
}

const zIndex = {
  /** @var 1000 */
  modal: 1000,
  /** @var 100 */
  popup: 100,
  /** @var 500 */
  tooltip: 500,
  snackbar: 1001,
}

const mediaQueryStub = (..._styles: any) => ''

const mediaStub = {
  desktop: mediaQueryStub,
  tablet: mediaQueryStub,
  smallTablet: mediaQueryStub,
  smallDesktop: mediaQueryStub,
  mobile: mediaQueryStub,
  custom: mediaQuery,
}

export const defaultTheme = {
  color,
  size,
  padding,
  shadow,
  zIndex,
  media: mediaStub,
  queries: {
    desktop: '',
    smallDesktop: '',
    tablet: '',
    smallTablet: '',
    mobile: '',
    custom: makeMediaQuery,
  },
}
